import React from 'react';
import PropTypes from 'prop-types';
// import Telegram from '../../../libs/telegram-send-message/dist/telegram-send-message';
import CloseIcon from '../../../svg/close.svg';
import { navigate } from 'gatsby'

import {
  NameInput,
  PhonesInput,
  MailInput,
  TimeInput,
  Terms,
  SubmitButton,
} from '.';

const FreeLessonModal = ({ open, closeModal, title }) => {
  const [name, setName] = React.useState('');
  const [time, setTime] = React.useState('09:00 - 13:00');
  const [phone, setPhone] = React.useState('');
  const [mail, setMail] = React.useState('');

  const send = () => {
  
      let xhr = new XMLHttpRequest();
        xhr.open("POST","https://payment.shoschool.com/sendMessage" ); 
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        const params = 'name=' + encodeURIComponent(name) +'&phone=' + encodeURIComponent(phone)+'&time=' + encodeURIComponent(time)+'&mail=' + encodeURIComponent(mail);
        xhr.send(params)
        xhr.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            navigate('/free-lesson')
          }
      }
      
    }


  return (
    <section className={open ? 'free-modal is-open' : 'free-modal'}>
      <div
        className={open ? 'free-modal__overlay is-open' : 'free-modal__overlay'}
        onClick={closeModal}
        role="presentation"
      ></div>
      <div className="free-modal__wrapper">
        <div
          className={
            open
              ? 'free-modal__form-wrapper is-open'
              : 'free-modal__form-wrapper'
          }
        >
          <button className="free-modal__close" onClick={closeModal}>
            close
            <CloseIcon className="free-modal__close-icon" />
          </button>
          <div className="free-modal__form-overflow">
            <div className="free-modal__form-header">
              <h3 className="free-modal__form-title">{title}</h3>
            </div>
            <form
              className={open ? 'free-modal__form is-open' : 'free-modal__form'}
              onSubmit={(e)=>{e.preventDefault();send()}}
            >
              <NameInput name={name} setName={setName} />
              <MailInput mail={mail} setMail={setMail} />
              <PhonesInput phone={phone} setPhone={setPhone} />
              <TimeInput time={time} setTime={setTime} />
              <Terms />
              <SubmitButton />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

FreeLessonModal.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default FreeLessonModal;
